<article [attr.data-automation-id]="'instatouch-prefill-card'">
  <form (ngSubmit)="emitEvent(instaTouch)" #instaTouch="ngForm">
    @switch (currentStage) {
    <!-- Autofill: Mobile initial number entry stages.initial-->
    @case (stages.initial) {
    <section>
      <!-- HEADING -->
      <header class="bl-display-sm--flex bl-text-align--center bl-text-align--center bl-margin-bottom--16 bl-flex-direction--column">
        <ea-svg
          class="bl-text-align--center"
          [svgClass]="isCoapplicant ? 'instatouch-coapp-svg' : 'instatouch-mobile-svg'"
          [minWidth]="'42px'"
          [minHeight]="'42px'"
          [width]="'42px'"
          [height]="'42px'"
        >
        </ea-svg>
        <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x-md--24">
          {{ getHeadingLabel('mobileHeader') }}
        </h2>
      </header>
      <p class="bl-text-style--default-text-1 bl-text-align--center bl-padding-x-md--24 bl-margin-bottom--24">{{ cardDescription }}</p>
      <!-- CONTENT -->
      <div id="content" class="bl-margin-top--40">
        <label class="bl-text-style--secondary-text-2 bl-margin-bottom--4 bl-required" for="mobileNumber">
          {{ getHeadingLabel('mobileNumberLabel') }}
        </label>
        <input
          class="bl-input bl-width--100"
          id="mobileNumber"
          data-automation-id="mobile-number"
          name="mobile"
          minlength="10"
          type="tel"
          inputmode="numeric"
          [(ngModel)]="mobileNumber"
          #mobile="ngModel"
          required
          [class.bl-error]="!validMobileNumber && instaTouch.touched"
          [class.bl-disabled]="lockMobileNumber || isLoading"
          [disabled]="lockMobileNumber || isLoading"
          aria-describedby="mobileNumberError"
          placeholder="(___) ___-____"
          mask="(000) 000-0000"
        />
        @if (!validMobileNumber && instaTouch.touched) {
        <p id="mobileNumberError" aria-live="polite" class="bl-error-msg bl-margin-top--4 bl-margin-bottom--0">
          {{ 'personalInfoAutofill/mobileNumberError' | dictionary }}
        </p>
        }
        <!-- SSN field for alloy prefill -->
        @if (isAlloyPrefill) {
        <section>
          <div class="bl-margin-top--24">
            <label class="bl-text-style--secondary-text-2 bl-margin-bottom--4 bl-required" for="ssn">
              {{ 'personalInfoAutofill/ssn' | dictionary }}
            </label>
            <input
              required
              class="bl-input bl-width--100"
              id="ssn"
              data-automation-id="ssn"
              name="ssn"
              minlength="4"
              maxlength="4"
              type="tel"
              inputmode="numeric"
              [(ngModel)]="ssnNumber"
              #ssn="ngModel"
              [disabled]="isLoading"
              [class.bl-disabled]="isLoading"
              [class.bl-error]="ssn?.touched && ssn?.invalid"
              aria-describedby="ssnError"
              mask="0000"
            />
            @if (ssn?.touched && ssn?.invalid) {
            <p id="ssnError" aria-live="polite" class="bl-error-msg bl-margin-bottom--0 bl-margin-top--4">
              {{ 'personalInfoAutofill/ssnError' | dictionary }}
            </p>
            }
          </div>
        </section>
        } @if (validMobileNumber) {
        <p
          aria-live="polite"
          class="bl-text-style--tertiary-text-1 bl-margin-top--16 bl-margin-bottom--0 bl-text-align--center"
          [innerHTML]="disclaimer"
        ></p>
        } @if(!errorMessage){
        <p class="bl-margin-top--24 bl-text-style--secondary-text-1 bl-text-align--center">
          <i class="cu-icons cu-lock bl-margin-right--8 bl-font-size--18"></i> <span [innerHTML]="creditScoreInfo"></span>
        </p>
        }
        <!-- Error alert -->
        <ea-alert
          [showAlert]="!!errorMessage"
          alertId="instatouch-get-passcode-alert"
          alertStatus="warning"
          [message]="errorMessage"
          [ngClass]="{ 'bl-display--block bl-margin-top--32 bl-margin-bottom--16 bl-max-width--tablet-width': errorMessage }"
        >
        </ea-alert>
      </div>
      <!-- CTA -->
      <ea-button-loader
        buttonType="button"
        buttonId="instatouch-get-passcode-button"
        buttonClass="bl-width--100 bl-margin-bottom--16"
        [text]="'personalInfoAutofill/send' | dictionary"
        [loading]="isLoading"
        (event)="emitEvent(instaTouch)"
      >
      </ea-button-loader>
      @if (proceedWithoutPhone.observers?.length !== 0) {
      <div class="bl-margin-x--auto bl-text-align--center">
        @if(('personalInfoAutofill/skipPrefill' | dictionary).length > 0) {
        <button
          type="button"
          class="bl-button bl-button-reverse bl-width--100"
          id="proceed-without-phone-pre-fill"
          (click)="proceedWithoutPhonePrefill()"
        >
          <span class="bl-white-space--normal">{{ 'personalInfoAutofill/skipPrefill' | dictionary }}</span>
        </button>
        }
        <p class="bl-text-style--default-text-1 bl-margin-top--8 bl-margin-bottom--0">
          {{ 'personalInfoAutofill/Offramp' | dictionary }}
        </p>
      </div>
      }
    </section>
    }
    <!-- Autofill: Confirm passcode-->
    @case (stages.passcode) {
    <section>
      <!-- HEADING -->
      <header
        class="bl-display-sm--flex bl-gap--16 bl-flex-direction--column bl-text-align--center bl-text-align-sm--left bl-align-items--center bl-margin-bottom--16"
      >
        <ea-svg
          class="bl-text-align--center"
          svgClass="instatouch-mobile-svg"
          [minWidth]="'42px'"
          [minHeight]="'42px'"
          [width]="'42px'"
          [height]="'42px'"
        >
        </ea-svg>
        <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x--24">
          {{ (isAlloyPrefill ? 'personalInfoAutofill/codeSent/alloy' : 'personalInfoAutofill/codeSent/instatouch') | dictionary }}
        </h2>
      </header>
      <!-- CONTENT -->
      <div id="content" [ngClass]="!isAlloyPrefill && 'bl-margin-bottom--40'">
        @if (getMobileNumberWithAsterisks(mobileNumber)) { @if (isAlloyPrefill) {
        <div class="bl-text-align--center bl-text-style--default-text-1 bl-margin-x--auto">
          <p class="bl-margin-top--0 bl-margin-bottom--24">
            {{ 'personalInfoAutofill/subautofill/alloy' | dictionary }} {{ getMobileNumberWithAsterisks(mobileNumber) }}
          </p>
          <p class="bl-margin-y--0">{{ 'personalInfoAutofill/subautofillAlloy' | dictionary }} <b>5 minutes.</b></p>
        </div>
        } @else {
        <p class="bl-text-align--center bl-text-style--default-text-1 bl-margin-bottom--16">
          {{ 'personalInfoAutofill/subautofill/instatouch' | dictionary }} {{ getMobileNumberWithAsterisks(mobileNumber) }}
        </p>
        } } @if (!isAlloyPrefill) {
        <code-input
          id="dx-code-input"
          #codeInput
          [isCodeHidden]="false"
          [isFocusingOnLastByClickIfFilled]="false"
          [disabled]="isLoading"
          [initialFocusField]="0"
          required
          (codeChanged)="onCodeChanged($event)"
          (codeCompleted)="onCodeCompleted($event)"
        >
        </code-input>
        }
        <!-- Passcode retry -->
        <div [ngClass]="!isAlloyPrefill && 'bl-text-align--center'" class="bl-margin-top--24">
          @if (errorMessage && !isAlloyPrefill) {
          <p id="getPassCode" aria-live="polite" class="bl-text-style--secondary-text-1 bl-error-msg bl-margin-bottom--0">
            {{ 'personalInfoAutofill/passcodeErrorMessage' | dictionary }}
            <button
              type="button"
              id="getNewPasscode"
              class="bl-font-color--primary bl-text-decoration--underline bl-font-weight--700"
              (click)="getNewPasscode()"
            >
              {{ 'personalInfoAutofill/passcodeErrorAction' | dictionary }}
            </button>
          </p>
          } @else {
          <p class="bl-text-align--center bl-text-style--secondary-text-1 bl-margin-bottom--0">
            {{ (isAlloyPrefill ? 'personalInfoAutofill/passcodeDesc/alloy' : 'personalInfoAutofill/passcodeDesc/instatouch') | dictionary }}
            <button
              type="button"
              id="getNewPasscode"
              class="bl-font-color--primary bl-text-decoration--underline bl-font-weight--700"
              (click)="getNewPasscode()"
            >
              {{ (isAlloyPrefill ? 'personalInfoAutofill/retryLink/alloy' : 'personalInfoAutofill/retryLink/instatouch') | dictionary }}
            </button>
          </p>
          }
        </div>
        <!-- Fill out manual application (repurposed to launch manual flow instead of separate CTA) -->
        @if (proceedWithoutPhone.observers?.length !== 0) {
        <div [ngClass]="!isAlloyPrefill && 'bl-text-align--center'">
          <p class="bl-text-align--center bl-margin-bottom--0 bl-text-style--secondary-text-1">
            {{ 'personalInfoAutofill/havingTrouble' | dictionary }}
            <button
              type="button"
              id="proceed-without-phone-link"
              class="bl-font-color--primary bl-text-decoration--underline bl-font-weight--700"
              (click)="proceedWithoutPhonePrefill()"
            >
              {{ 'personalInfoAutofill/havingTroubleAction' | dictionary }}
            </button>
          </p>
        </div>
        }
        <!-- Info alert -->
        <ea-alert
          [showAlert]="showCodeSentAlert && showNewCodeSentAlert"
          alertId="instatouch-confirm-passcode-alert"
          alertStatus="info"
          [message]="
            isAlloyPrefill
              ? ('personalInfoAutofill/newCodeSent/alloy' | dictionary)
              : ('personalInfoAutofill/newCodeSent/instatouch' | dictionary)
          "
          [ngClass]="{ 'bl-display--block bl-margin-top--32 bl-max-width--tablet-width': showCodeSentAlert && showNewCodeSentAlert }"
        >
        </ea-alert>
      </div>
    </section>
    }
    <!-- Autofill: Confirm identity stages.identity-->
    @case (stages.identity) {
    <section>
      @if(!isLoading){
      <!-- HEADING -->
      <header
        class="bl-display--flex bl-flex-direction--column bl-text-align--center bl-text-align-sm--left bl-align-items--center bl-margin-bottom--16"
      >
        <ea-svg
          class="bl-text-align--center"
          svgClass="instatouch-id-svg"
          [minWidth]="'52px'"
          [minHeight]="'42px'"
          [width]="'52px'"
          [height]="'42px'"
        >
        </ea-svg>
        <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x--24">
          {{ 'personalInfoAutofill/identityHeader' | dictionary }}
        </h2>
      </header>
      <!-- CONTENT -->
      <div id="content" class="bl-margin-y--40">
        <!-- Zip code field -->
        <div class="bl-margin-bottom--16">
          <label class="bl-text-style--secondary-text-2 bl-margin-bottom--4 bl-required" for="zipcode">
            {{ getHeadingLabel('zipCode') }}
          </label>
          <input
            class="bl-input bl-width--100"
            id="zipcode"
            data-automation-id="zip-code"
            name="zipcode"
            minlength="5"
            maxlength="5"
            type="tel"
            inputmode="numeric"
            required
            [(ngModel)]="zipCode"
            #zipcode="ngModel"
            [disabled]="isLoading"
            [class.bl-disabled]="isLoading"
            [class.bl-error]="zipcode?.touched && zipcode?.invalid"
            aria-describedby="zipError"
            mask="00000"
          />
          @if (zipcode?.touched && zipcode?.invalid) {
          <p id="zipError" aria-live="polite" class="bl-error-msg bl-margin-bottom--0 bl-margin-top--4">
            {{ 'personalInfoAutofill/zipError' | dictionary }}
          </p>
          }
        </div>
        <!-- SSN field -->

        <div>
          <label class="bl-text-style--secondary-text-2 bl-margin-bottom--4 bl-required" for="ssn">
            {{ 'personalInfoAutofill/ssn' | dictionary }}
          </label>
          <input
            class="bl-input bl-width--100"
            id="ssn"
            data-automation-id="ssn"
            name="ssn"
            minlength="4"
            maxlength="4"
            type="tel"
            inputmode="numeric"
            required
            [(ngModel)]="ssnNumber"
            #ssn="ngModel"
            [disabled]="isLoading"
            [class.bl-disabled]="isLoading"
            [class.bl-error]="ssn?.touched && ssn?.invalid"
            aria-describedby="ssnError"
            mask="0000"
          />
          @if (ssn?.touched && ssn?.invalid) {
          <p id="ssnError" aria-live="polite" class="bl-error-msg bl-margin-bottom--0 bl-margin-top--4">
            {{ 'personalInfoAutofill/ssnError' | dictionary }}
          </p>
          }
          <!-- Error alert -->
          <ea-alert
            [showAlert]="!!errorMessage"
            alertId="instatouch-confirm-identity-alert"
            alertStatus="warning"
            [message]="getIdentityErrorMessage"
            [ngClass]="{ 'bl-display--block bl-margin-top--32 bl-max-width--tablet-width': errorMessage }"
          >
          </ea-alert>
        </div>
      </div>
      @if(!errorMessage){
      <p class="bl-text-style--secondary-text-1 bl-text-align--center">
        <i class="cu-icons cu-lock bl-margin-right--8 bl-font-size--18"></i> <span [innerHTML]="creditScoreInfo"></span>
      </p>
      }
      <!-- CTA -->
      <ea-button-loader
        buttonType="button"
        buttonId="instatouch-confirm-identity-button"
        buttonClass="bl-width--100 bl-margin-bottom--16"
        [text]="'personalInfoAutofill/continue' | dictionary"
        [loading]="isLoading"
        (event)="emitEvent(instaTouch)"
      >
      </ea-button-loader>
      @if (proceedWithoutPhone.observers?.length !== 0) {
      <div class="bl-margin-x--auto bl-text-align--center">
        @if(('personalInfoAutofill/skipPrefill' | dictionary).length > 0) {
        <button
          type="button"
          class="bl-button bl-button-reverse bl-width--100"
          id="proceed-without-phone-pre-fill"
          (click)="proceedWithoutPhonePrefill()"
        >
          <span class="bl-white-space--normal">{{ 'personalInfoAutofill/skipPrefill' | dictionary }}</span>
        </button>
        }
        <p class="bl-text-style--default-text-1 bl-margin-top--8 bl-margin-bottom--0">
          {{ 'personalInfoAutofill/Offramp2' | dictionary }}
        </p>
      </div>
      } } @else {
      <header class="bl-display-sm--flex bl-text-align--center bl-text-align--center bl-margin-bottom--16 bl-flex-direction--column">
        <h2 class="bl-text-style--display-3 bl-margin--0 bl-text-align--center bl-padding-x-md--24">
          {{ 'personalInfoAutofill/completeHeading' | dictionary }}
        </h2>
      </header>
      <p class="bl-text-style--default-text-1 bl-text-align--center bl-padding-x-md--24 bl-margin-bottom--24">
        {{ 'personalInfoAutofill/completeDesc' | dictionary }}
      </p>
      <ecp-content-spinner class="bl-margin-x--auto bl-margin-y--40 bl-display--block" [spinnerSmall]="true"></ecp-content-spinner>
      @if (proceedWithoutPhone.observers?.length !== 0) {
      <p class="bl-margin-x--auto bl-text-align--center">
        <span class="bl-text-style--default-text-1 bl-margin-bottom--0">{{ 'personalInfoAutofill/tooLong' | dictionary }}</span>
        @if(('personalInfoAutofill/skipPrefill' | dictionary).length > 0) {
        <button
          type="button"
          class="bl-text-decoration--underline bl-font-color--primary bl-margin-x--4"
          id="proceed-without-phone-pre-fill"
          (click)="proceedWithoutPhonePrefill()"
        >
          <span class="bl-white-space--normal">{{ 'personalInfoAutofill/skipPrefill' | dictionary }}</span>
        </button>
        }
      </p>
      } }
    </section>
    } }
  </form>
</article>
